import { createContext } from 'react';

import type { TCourse } from '../types';

type CourseContextState = {
  course: TCourse & {
    playerUrl: string;
  };
  organizationSlug: string;
};

export const CourseContext = createContext<CourseContextState | undefined>(
  undefined,
);

type CourseProviderProps = {
  course: TCourse;
  organizationSlug: string;
};

const CourseProvider: React.FC<
  React.PropsWithChildren<CourseProviderProps>
> = ({ course, organizationSlug, children }) => {
  const value: CourseContextState = {
    course: {
      ...course,
      playerUrl: `/clases/v2/${course.originalId}/detalle/`,
    },
    organizationSlug: organizationSlug,
  };

  return (
    <CourseContext.Provider value={value}>{children}</CourseContext.Provider>
  );
};

export default CourseProvider;
